module.exports = __webpack_public_path__ + "static/img/qnset1.dddb8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnset1.png
// module id = 355
// module chunks = 0